import { WidgetDefinition } from '../models/WidgetDefinition';

export const TagsTrendWidgetDefinition: WidgetDefinition = {
    baseType: 'trend',
    group: 'Charts',
    hasImage: true,
    highlights: ['Trend over time as points, lines or bars', 'You can also stack or offset series, aggregate values or show alarms and logbook entries'],
    icon: 'fa-line-chart',
    sortingOrder: 100,
    title: 'Tags trend',
    type: 'tagsTrend'
};